import { initializeTheme } from '@/lib/theme/theme-store'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { AppProviders } from '@/app/AppProviders'
import { router } from '@/app/router'
import { initializeObservability } from '@/lib/observability'
import { loadRuntimeConfig } from '@/lib/runtime-config'
import { installChunkLoadRecovery } from '@/lib/chunk-load-recovery'
import './index.css'

initializeTheme()
installChunkLoadRecovery()

// Start configuration loading immediately, but do not keep the public landing
// page blank while this network request is in flight. Protected route loaders
// await the same deduplicated request before mounting API-backed pages.
void loadRuntimeConfig()
  .then(initializeObservability)
  .catch(() => undefined)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </StrictMode>,
)
